/**
 * <TimeRange />
 *
 * Make a range of time
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import TimePicker from 'components/UI/Form/Fields/TimePicker2';
// import TimePicker from 'rc-time-picker';
//import 'rc-time-picker/assets/index.css';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import './TimeRange.scss';

import { START_END_MIN_DIFF } from '../../constants'
import { TIME_FORMAT } from '../../constants'

import { Arrow } from 'components/UI/Svg'

const DEFAULT_START = moment('09:00', TIME_FORMAT);
const DEFAULT_END = moment('09:30', TIME_FORMAT);
const DEFAULT_USE_12HOURS = true;

// this functions is a widget function used by a form
export function timerange (props) {
  let {
    value
  } = props;
  let startMoment, endMoment;

  if (typeof value === 'string') {
    let parts = value.split(':::');
    startMoment = moment(parts[0], 'HH:mm');
    endMoment = moment(parts[1], 'HH:mm');
  }

  return (
    <TimeRange
      {...props}
      {...props.options}
      startMoment={startMoment}
      endMoment={endMoment}
      onChange={({startTime, endTime})=>{console.log('endTime', endTime); props.onChange(startTime + ':::' + endTime); }}/>
  );
}

class TimeRange extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    dataFormat: PropTypes.string,
    startEndMinDiff: PropTypes.number,
  }

  static defaultProps = {
    showSecond: false,
    format: 'h:mm a',
    startTime: '',
    endTime: '',
  }

  constructor(props) {
    super(props);
    this.onStartTimeChange = this.onStartTimeChange.bind(this);
    this.onEndTimeChange = this.onEndTimeChange.bind(this);
    this.onReset = this.onReset.bind(this);

    this.state = {
      startMoment: props.startMoment || DEFAULT_START,
      endMoment: props.endMoment || DEFAULT_END,
    }
  }

  componentWillReceiveProps(nextProps) {
    let {
      startTime,
      startMoment,
      endTime,
      endMoment,
    } = nextProps;

    if (startTime) {
      this.setState({
        startTime,
      });
    }

    if (startMoment) {
      this.setState({
        startMoment,
      });
    }

    if (endTime) {
      this.setState({
        endTime,
      });
    }
    if (endMoment) {
      this.setState({
        endMoment,
      });
    }
  }

  //
  // This is how it works,
  // We compare end time and start time, if start time is equal to end time OR it is later than end time,
  // we automatically adjust the difference between these two to be START_END_MIN_DIFF apart which could be
  // 5, 15, 30 mins. Users are ALLOWED to adjust the difference as small as to 1 minute.
  //
  onStartTimeChange(startMoment) {
    let {
      endMoment,
    } = this.state;

    // let isStartTimeAfterEndTime;
    // let isStartTimeSameAsEndTime;

    // if (endMoment) {
    //   isStartTimeAfterEndTime = startMoment.isAfter(endMoment, 'minute');
    //   isStartTimeSameAsEndTime = startMoment.isSame(endMoment, 'minute');

    //   this.setState({
    //     diff: endMoment.diff(startMoment, 'minute'),
    //     endMoment: moment(startMoment).add(5, 'minutes')
    //   },()=>{
    //     console.log('end', this.state.endMoment)
    //     console.log('start', startMoment)
    //     console.log('diff', this.state.diff)
    //   });
    // }

    let { dataFormat } = this.props;
    let adjustedEndMoment = startMoment.isSameOrAfter(endMoment, 'minute')? cloneDeep(startMoment).add(5, 'm'): endMoment
    this.setState({
      startMoment,
      endMoment: adjustedEndMoment,
      startTime: startMoment.format(dataFormat || TIME_FORMAT),
      endTime: adjustedEndMoment.format(dataFormat || TIME_FORMAT),
    }, ()=>{
      this.props.onChange(this.state);
    });
  }

  onEndTimeChange(endMoment) {
    let {
      startMoment,
    } = this.state;

    // let isStartTimeAfterEndTime;
    // let isStartTimeSameAsEndTime;

    // if (startMoment) {
    //   isStartTimeAfterEndTime = startMoment.isAfter(endMoment, 'minute');
    //   isStartTimeSameAsEndTime = startMoment.isSame(endMoment, 'minute');

    //   this.setState({
    //     diff: endMoment.diff(startMoment, 'minute'),
    //   });
    // }

    let { dataFormat } = this.props;
    let adjustedStartMoment = endMoment.isSameOrBefore(startMoment, 'minute')? cloneDeep(endMoment).subtract(5, 'm'): startMoment;
    this.setState({
      startMoment: adjustedStartMoment,
      endMoment,
      startTime: adjustedStartMoment.format(dataFormat || TIME_FORMAT),
      endTime: endMoment.format(dataFormat || TIME_FORMAT)
    }, ()=>{
      this.props.onChange(this.state);
    });
  }

  onReset() {
    let {
      onReset,
    } = this.props;

    this.setState({
      startMoment: null,
      endMoment: null,
    }, ()=>{
      if (typeof onReset == 'function') {
        onReset();
      }
    });

  }

  render() {
    let {
      showSecond,
      format,
      hasValue,
      use12Hours = DEFAULT_USE_12HOURS,
      minuteStep,
    } = this.props;

    let {
      startMoment,
      endMoment,
    } = this.state;

    const itDoesHaveValue = this.props.hasValue || (startMoment && endMoment);


    //
    // We must change language to English by startMoment.lang('en')
    //
    if(startMoment){
      startMoment = startMoment.lang('en')
    }
    if(endMoment){
      endMoment = endMoment.lang('en')
    }

    return (
      <div className={classnames('time-picker', 'form-input', { 'has-value': itDoesHaveValue, })}>
        <div className='time-picker-input'>
          <div className='start-time'>
            <TimePicker
              value={startMoment}
              minuteStep={minuteStep}
              onChange={this.onStartTimeChange}
              format={format}
              use12Hours={use12Hours}
              showSecond={showSecond}
              placeholder={__('Start Time', 'TimeRange')} />
          </div>
          {Arrow}
          <div className='end-time'>
            <TimePicker
              value={endMoment}
              minuteStep={minuteStep}
              onChange={this.onEndTimeChange}
              format={format}
              use12Hours={use12Hours}
              showSecond={showSecond}
              placeholder={__('End Time', 'TimeRange')} />
          </div>
          <div className='reset-button' onClick={this.onReset}>x</div>
        </div>
      </div>
    )
  }
}

export default TimeRange;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/TimeRange/index.js